export default {
  "content": "<path d=\"M12 4H6.5v16h11v-3.5h2V20a2 2 0 01-2 2h-11a2 2 0 01-2-2V4a2 2 0 012-2H12v2z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.661 1.701a1 1 0 011.556 1.24L15.78 6.744l5.041 1.711a1 1 0 01.393 1.649l-6.875 7a1.001 1.001 0 01-1.556-1.24l2.436-3.805-5.04-1.71a1.001 1.001 0 01-.393-1.648l6.875-7zM12.33 8.967l5.397 1.83.944-.96-5.397-1.831-.944.96z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};